import { Clickable } from '~shared/ui/clickable';

import { TableCell } from '@platform-ui/dataTable';

import type { Header } from '@tanstack/react-table';
import { flexRender } from '@tanstack/react-table';

import type { SortingState } from '../../lib/table-state';
import { SortLabel } from '../sort-label/sort-label';

type Props<TData> = {
  header: Header<TData, unknown>;
  isSortable: boolean;
  sort?: SortingState;
  onSortChange?: (id: string) => void;
};

export function HeaderCell<T>({
  header,
  isSortable,
  sort,
  onSortChange,
}: Props<T>) {
  return (
    <TableCell theme="secondary" variant="head" size="large">
      <Clickable
        disabled={!isSortable}
        onClick={() => isSortable && onSortChange?.(header.column.id)}
      >
        <div className="flex items-center">
          {flexRender(header.column.columnDef.header, header.getContext())}
          {isSortable && (
            <div className="ml-2 flex items-center">
              <SortLabel
                active={sort?.orderBy === header.column.id}
                direction={sort?.direction}
              />
            </div>
          )}
        </div>
      </Clickable>
    </TableCell>
  );
}
